import { render, staticRenderFns } from "./modules.vue?vue&type=template&id=4cea2866&scoped=true"
import script from "./modules.vue?vue&type=script&lang=ts"
export * from "./modules.vue?vue&type=script&lang=ts"
import style0 from "./modules.vue?vue&type=style&index=0&id=4cea2866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cea2866",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxAssociation: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/Association.vue').default,ReportingHomeSummary: require('/home/runner/work/assessment-service/assessment-service/frontend/components/reporting/HomeSummary.vue').default,IxSectionText: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/SectionText.vue').default,IxSection: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/Section.vue').default})
